import {useQuery} from "@tanstack/react-query";
import {useEffect, useState} from "react";
import {getGroups} from "../services/GroupService";
import {useLogout} from "./useLogout";

export function useGroups({enabled = true} = {}) {
    const [groups, setGroups] = useState([]);

    const logout = useLogout();
    const {data, isError, error, refetch, isFetching} = useQuery({
        queryKey: ["groups"],
        queryFn: getGroups,
        enabled: enabled,
        retry: false,
    });

    useEffect(() => {
        if (isError && error.response && error.response.status) {
            if (error.response.status === 401) {
                logout();
            }
        }
    }, [isError, error]);

    useEffect(() => {
        if (data) {
            setGroups(data);
        }
    }, [data]);

    return [groups, refetch, isFetching];
}
